import { trackError, errorMessage } from 'helpers/error';
export function handleFetchMoreError(error: any) {
  // Catch error caused by trying update result of fetchmore after
  // component has already been unmounted
  // Different messages depending on minification & unmounting stage
  const tryingToUpdateUnmountedFeed =
    error.message.includes('Invariant Violation: 17') ||
    error.message.includes("ObservableQuery with this id doesn't exist") ||
    error.message.includes("Cannot read property 'me' of undefined");
  if (!tryingToUpdateUnmountedFeed) {
    trackError(errorMessage.FetchMoreError, error);
  }
  return;
}

export function criticalFeedError(error: any) {
  let criticalError = false;
  error.graphQLErrors.forEach((err: any, i: any) => {
    if (!err.message.includes('Sharing not enabled for node')) {
      criticalError = true;
    }
  });
  return criticalError ? true : false;
}

export function groupNotFoundError(errors: any) {
  let groupNotFound = false;
  errors.forEach((err: any, i: any) => {
    if (err.extensions.code.includes('NOT-FOUND')) {
      groupNotFound = true;
    }
  });
  return groupNotFound ? true : false;
}
